// src/components/ChangePasswordModal.jsx

import { useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShield, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { changePassword } from "../api/hrm/employees/employeeInfo";
import { showSuccessToast, showErrorToast } from "./ConfirmDialog";

export default function ChangePasswordModal({ open, onClose, user }) {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState("");

  if (!open) return null;

  const validatePassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/.test(password);

  const handleSubmit = async () => {
    if (!validatePassword(newPass)) {
      setError("Mật khẩu mới phải ≥6 ký tự, gồm chữ hoa, chữ thường và số.");
      return;
    }
    if (newPass !== confirmPass) {
      setError("Xác nhận mật khẩu không khớp.");
      return;
    }

    try {
      await changePassword(user?.id, oldPass, newPass);
      showSuccessToast("Đổi mật khẩu thành công!");
      onClose();
    } catch (err) {
      showErrorToast(err?.message || "Lỗi khi đổi mật khẩu");
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <motion.div
        initial={{ scale: 0.9, opacity: 0, y: 40 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 40 }}
        className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-md overflow-hidden relative z-[10000]"
      >
        <div className="p-8 border-b border-gray-50 flex items-center gap-4">
          <div className="bg-red-700 p-3 rounded-2xl text-white shadow-lg shadow-red-100">
            <FontAwesomeIcon icon={faShield} size="lg" />
          </div>
          <div>
            <h2 className="text-xl font-black text-gray-800 uppercase tracking-tight">
              Đổi <span className="text-red-700">Mật khẩu</span>
            </h2>
          </div>
        </div>

        <div className="p-8 space-y-4">
          <input
            type="password"
            placeholder="Mật khẩu hiện tại"
            className="w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-red-500 p-4 rounded-2xl outline-none font-bold text-sm"
            value={oldPass}
            onChange={(e) => setOldPass(e.target.value)}
          />
          <input
            type="password"
            placeholder="Mật khẩu mới"
            className="w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-red-500 p-4 rounded-2xl outline-none font-bold text-sm"
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
          />
          <input
            type="password"
            placeholder="Xác nhận mật khẩu mới"
            className="w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-red-500 p-4 rounded-2xl outline-none font-bold text-sm"
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
          />
          {error && (
            <div className="text-red-500 text-[11px] font-bold uppercase italic px-2">
              {error}
            </div>
          )}
        </div>

        <div className="p-8 bg-gray-50/50 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-3 font-black text-gray-400 uppercase text-[10px] tracking-widest"
          >
            Hủy
          </button>
          <button
            onClick={handleSubmit}
            className="px-8 py-3 bg-red-700 text-white rounded-xl font-black uppercase text-[10px] tracking-widest shadow-lg shadow-red-100 flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faCircleCheck} /> Xác nhận
          </button>
        </div>
      </motion.div>
    </div>,
    document.body
  );
}
